export enum EAnnualDiscountVersionStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CLOSED = 'CLOSED',
}

export type TAnnualDiscountTierRow = {
  id: number
  label: string
  minRevenue: number
  maxRevenue: number | null
  rate: number
  sortOrder: number
}

export type TAnnualDiscountVersionSummary = {
  id: number
  effectiveYear: number
  status: EAnnualDiscountVersionStatus
  publishedAt: string | null
  publishedBy: number | null
  note: string | null
  tierCount: number
  createdAt: string
  updatedAt: string
}

export type TAnnualDiscountVersionDetail = {
  id: number
  effectiveYear: number
  status: EAnnualDiscountVersionStatus
  publishedAt: string | null
  publishedBy: number | null
  note: string | null
  tiers: TAnnualDiscountTierRow[]
  createdAt: string
  updatedAt: string
}

export type TWriteAnnualTierRow = {
  label: string
  minRevenue: number
  maxRevenue: number | null
  rate: number
  sortOrder: number
}

export type TWriteAnnualTierLadder = {
  tiers: TWriteAnnualTierRow[]
  note?: string | null
}

export type TCloneAnnualDiscountVersion = {
  targetYear: number
  note?: string | null
}
